// extracted by mini-css-extract-plugin
module.exports = {"base":"Row__base__2FJr3","center":"Row__center__bFCoq","verticalCenter":"Row__verticalCenter__1XrtN"};